
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"20","height":"20","viewBox":"0 0 20 20","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M19.4675 3.54673C20.1775 4.27571 20.1775 5.45762 19.4675 6.1866L9.46747 16.4533C8.75742 17.1822 7.60621 17.1822 6.89617 16.4533L0.532533 9.91993C-0.177511 9.19095 -0.177511 8.00905 0.532533 7.28007C1.24258 6.55109 2.39379 6.55109 3.10383 7.28007L8.18182 12.4935L16.8962 3.54673C17.6062 2.81776 18.7574 2.81776 19.4675 3.54673Z"}})])
          )
        }
      }
    